import { useState } from "react";
import { observer } from "mobx-react-lite";
import { Form, Flex } from "antd";
import { useStores } from "stores";
import { useNotificationContext } from "providers";
import { NOTIFICATION_TYPE_ENUM } from "interfaces";
import { _isRequired, getAvailableUserRoles, parseErrorMessage } from "utils";
import { UserSelect, CustomButton, LinkButton, MultiplySelect } from "ui";
import { connectCompanyAndUser } from "services";
import { routes } from "constants/routes";
import { useNavigate } from "react-router-dom";
import { FORM_VALIDATION_DEBOUNCE } from "constants/form";
export const AddUserModal = observer(() => {
  const { actionModals, companyCard, companyUsers } = useStores();
  const { openNotification } = useNotificationContext();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [form] = Form.useForm();

  const closeModal = () => {
    actionModals.closeAll();
  };

  const onFinish = async () => {
    const values = form.getFieldsValue();

    setLoading(true);

    await connectCompanyAndUser(
      {
        id: companyCard.card.id,
        userId: values.id,
      },
      values.roles
    )
      .then(() => {
        openNotification({
          message: "Пользователь добавлен",
          type: NOTIFICATION_TYPE_ENUM.SUCCESS,
        });
        setTimeout(() => {
          companyUsers.fetch();
        }, 1500);
        closeModal();
      })
      .catch((e) => {
        openNotification({
          description: parseErrorMessage(e),
          type: NOTIFICATION_TYPE_ENUM.ERROR,
        });
      })
      .finally(() => setLoading(false));
  };

  const newUserHandler = () => {
    closeModal();
    navigate(`/${routes.users}/create?companyId=${companyCard.card.id}`);
  };

  return (
    <Form form={form} name="addUser" onFinish={onFinish}>
      <Flex vertical gap="small">
        <UserSelect
          inputProps={{
            disabled: loading,
          }}
          name="id"
        />
        <Form.Item
          name="roles"
          className="full-width"
          rules={[_isRequired("Выберите хотя бы одну роль")]}
          validateDebounce={FORM_VALIDATION_DEBOUNCE}
        >
          <MultiplySelect
            placeholder="Роли пользователя"
            disabled={loading}
            options={getAvailableUserRoles(companyCard.card.role)}
          />
        </Form.Item>
        <LinkButton onClick={newUserHandler}>Создать нового пользователя</LinkButton>
        <Form.Item>
          <Flex gap="large" className="margin-top-lg">
            <CustomButton loading={loading} htmlType="submit">
              Добавить
            </CustomButton>
            <CustomButton variant="outlined" loading={loading} htmlType="button" onClick={closeModal}>
              Отмена
            </CustomButton>
          </Flex>
        </Form.Item>
      </Flex>
    </Form>
  );
});
